<template>
  <nav data-testid="admin-console-side-nav" class="admin-console-side-nav" aria-label="Admin menu">
    <div data-testid="admin-console-side-nav__header" class="admin-console-side-nav__header">
      Admin menu
    </div>

    <div data-testid="admin-console-side-nav__list" class="admin-console-side-nav__list">
      <button
        v-for="item in navItems"
        :key="item.key"
        :data-testid="`admin-console-side-nav__item--${item.key}`"
        type="button"
        class="admin-console-side-nav__item"
        :class="{ 'admin-console-side-nav__item--active': activeKey === item.key }"
        :disabled="!item.href"
        @click="$emit('nav-click', item)"
      >
        <img
          :data-testid="`admin-console-side-nav__icon--${item.key}`"
          :src="item.icon"
          alt=""
          class="admin-console-side-nav__icon"
          aria-hidden="true"
        />
        <span
          :data-testid="`admin-console-side-nav__label--${item.key}`"
          class="admin-console-side-nav__label"
        >{{ item.label }}</span>
      </button>
    </div>
  </nav>
</template>

<script>
import { ADMIN_CONSOLE_NAV } from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'AdminConsoleSideNav',
  props: {
    activeKey: { type: String, default: 'agent-settings' },
  },
  emits: ['nav-click'],
  computed: {
    navItems() {
      return ADMIN_CONSOLE_NAV;
    },
  },
};
</script>

<style lang="scss" scoped src="./AdminConsoleSideNav.scss"></style>
